import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setTimezone } from "@/lib/format";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out
  const [meta, setMeta] = useState({});

  const apply = (data) => {
    setUser(data.user);
    setMeta(data.meta || {});
    setTimezone(data.meta?.timezone);
  };

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      apply(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
    const onLogout = () => setUser(false);
    window.addEventListener("qdb:logout", onLogout);
    return () => window.removeEventListener("qdb:logout", onLogout);
  }, [refreshMe]);

  const login = async (email, password, remember) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    apply(data);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, meta, login, logout, refreshMe }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
